import React from 'react';
import { Container, Typography, Box } from '@mui/material';

const Voorwaarden = () => {
  return (
    <Container maxWidth="md" sx={{ py: 8 }}>
      <Typography variant="h1" gutterBottom>
        Algemene Voorwaarden
      </Typography>
      
      <Box sx={{ mb: 4 }}>
        <Typography variant="h2" gutterBottom>
          Artikel 1 - Definities
        </Typography>
        <Typography paragraph>
          In deze voorwaarden wordt verstaan onder:
        </Typography>
        <ul>
          <li>Dienstverlener: Sterk aan het Werk</li>
          <li>Klant: de natuurlijke of rechtspersoon die een overeenkomst aangaat met de dienstverlener</li>
          <li>Overeenkomst: de overeenkomst tussen de dienstverlener en de klant</li>
        </ul>
      </Box>

      <Box sx={{ mb: 4 }}>
        <Typography variant="h2" gutterBottom>
          Artikel 2 - Toepasselijkheid
        </Typography>
        <Typography paragraph>
          Deze voorwaarden zijn van toepassing op alle aanbiedingen en overeenkomsten van Sterk aan het Werk.
        </Typography>
      </Box>

      <Box sx={{ mb: 4 }}>
        <Typography variant="h2" gutterBottom>
          Artikel 3 - Aanbiedingen
        </Typography>
        <Typography paragraph>
          Alle aanbiedingen zijn vrijblijvend, tenzij anders aangegeven. De dienstverlener behoudt zich het recht voor om aanbiedingen te wijzigen of in te trekken.
        </Typography>
      </Box>

      <Box sx={{ mb: 4 }}>
        <Typography variant="h2" gutterBottom>
          Artikel 4 - Prijzen
        </Typography>
        <Typography paragraph>
          Alle genoemde prijzen zijn in euro's en exclusief BTW, tenzij anders vermeld.
        </Typography>
      </Box>

      <Box sx={{ mb: 4 }}>
        <Typography variant="h2" gutterBottom>
          Artikel 5 - Betaling
        </Typography>
        <Typography paragraph>
          Betaling dient te geschieden binnen 14 dagen na factuurdatum, tenzij anders overeengekomen.
        </Typography>
      </Box>

      <Box sx={{ mb: 4 }}>
        <Typography variant="h2" gutterBottom>
          Artikel 6 - Annulering
        </Typography>
        <Typography paragraph>
          Bij annulering van een afspraak geldt een termijn van 24 uur. Bij te late annulering wordt het volledige bedrag in rekening gebracht.
        </Typography>
      </Box>

      <Box sx={{ mb: 4 }}>
        <Typography variant="h2" gutterBottom>
          Artikel 7 - Aansprakelijkheid
        </Typography>
        <Typography paragraph>
          De dienstverlener is niet aansprakelijk voor schade die voortvloeit uit het gebruik van de diensten, tenzij er sprake is van opzet of grove schuld.
        </Typography>
      </Box>

      <Box sx={{ mb: 4 }}>
        <Typography variant="h2" gutterBottom>
          Artikel 8 - Geschillen
        </Typography>
        <Typography paragraph>
          Op deze voorwaarden is Nederlands recht van toepassing. Geschillen worden voorgelegd aan de bevoegde rechter in Nederland.
        </Typography>
      </Box>

      <Box sx={{ mb: 4 }}>
        <Typography variant="h2" gutterBottom>
          Contact
        </Typography>
        <Typography paragraph>
          Voor vragen over deze voorwaarden kunt u contact opnemen via:
        </Typography>
        <Typography>
          Email: info@sterkaaninhetwerk.nl<br />
          Telefoon: 06-12345678
        </Typography>
      </Box>
    </Container>
  );
};

export default Voorwaarden; 